const ROUTES = {
  HOME: '/',
  ABOUT: '/#over',
  SUPERVISION: '/supervisie',
  SUPERVISION_FULL: '/supervisie',
  THERAPY: '/#aanbod',
  THERAPY_FULL: '/therapie',
  CONTACT: '/#contact',
  CONTACT_FULL: '/contact'
};

export default ROUTES;
